<template>
  <v-app>
    <v-app >
      <router-view></router-view>
    </v-app>
  </v-app>
</template>

<script>
// import HelloWorld from './components/HelloWorld'
// import('./assets/css/style.css');
import('./assets/css/style_sass.scss')

export default {
  name: 'App',

  // components: {
  //   HelloWorld
  // },
  created () {
    if (this.$workbox) {
      this.$workbox.addEventListener('waiting', () => {
        this.showUpdateUI = true
      })
    }
  },
  async accept () {
    this.showUpdateUI = false
    await this.$workbox.messageSW({ type: 'SKIP_WAITING' })
  },

  data: () => ({
    //
  })
}
</script>
